const TextBlockSchema = (data) => {
  return {
    title: '',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],
    properties: {},
    required: [],
  };
};

export default TextBlockSchema;
